import { SKILL_EIXO, SKILL_LABEL, getSkillEixo } from '../domain/skills.js';
import { SKILL_ALIASES, normalizarHabilidadeId } from './skillAliases.js';

export const habilidadeLabels = Object.freeze({
  ...SKILL_LABEL,
  ...Object.fromEntries(Object.entries(SKILL_ALIASES).map(([legacy, canonical]) => [legacy, SKILL_LABEL[canonical] || canonical])),
});

export const habilidadeEixo = Object.freeze({
  ...SKILL_EIXO,
  ...Object.fromEntries(Object.entries(SKILL_ALIASES).map(([legacy, canonical]) => [legacy, getSkillEixo(canonical)])),
});

export function generateId(prefix = 'id') {
  return `${prefix}_${Math.random().toString(36).slice(2, 10)}`;
}

export function todayISO() {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;
}

export function formatDate(date) {
  if (!date) return '-';
  const [y, m, d] = String(date).split('T')[0].split('-');
  return y && m && d ? `${d}/${m}/${y}` : date;
}

export function calculateAge(date) {
  if (!date) return '-';
  const [y, m, d] = date.split('-').map(Number);
  const birth = new Date(y, m - 1, d);
  const now = new Date();
  let age = now.getFullYear() - birth.getFullYear();
  const monthDiff = now.getMonth() - birth.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && now.getDate() < birth.getDate())) age -= 1;
  return `${age} anos`;
}

export function normalizeNeed(value = '') {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '_')
    .replace(/^_|_$/g, '');
}

export function scoreToLabel(value) {
  if (value === null || value === undefined || value === '' || !Number.isFinite(Number(value))) return 'Não observado';
  const score = Number(value);
  if (score >= 80) return 'Consolidado';
  if (score >= 60) return 'Em desenvolvimento avançado';
  if (score >= 40) return 'Em desenvolvimento';
  if (score > 0) return 'Necessita apoio intensivo';
  return 'Ainda não demonstrado';
}

export function eixoFromHabilidade(habilidadeId) {
  return getSkillEixo(normalizarHabilidadeId(habilidadeId));
}
